import {
	Dispatch,
	ReactNode,
	RefObject,
	SetStateAction,
	useEffect,
	useRef,
} from 'react';
// STYLES
import styles from './sticky.module.scss';

export interface StickyProps {
	children: ReactNode;
	scrollContainerRef: RefObject<HTMLElement>;
	className?: string;
	isSticky: boolean;
	setIsSticky: Dispatch<SetStateAction<boolean>>;
	isDesktopResolution: boolean;
	stickyContainerRef: RefObject<HTMLElement>;
}

export const Sticky = ({
	children,
	className,
	isDesktopResolution,
	isSticky,
	scrollContainerRef,
	setIsSticky,
	stickyContainerRef,
	...otherProps
}: StickyProps) => {
	const cssClasses = [
		styles.sticky,
	];

	if (className) cssClasses.push(className);

	const initialStickyTop = useRef<number | null>(null);

	const handleScroll = () => {
		const isWindowScrolling = scrollContainerRef?.current === undefined;
		const scrollTop = isWindowScrolling
			? window.scrollY
			: scrollContainerRef.current.scrollTop;

		/* istanbul ignore next */
		const stickyTop = stickyContainerRef.current?.getBoundingClientRect().top;

		if (initialStickyTop.current === null && stickyTop !== undefined) {
			initialStickyTop.current = stickyTop;
		}

		const isStickyNow = isWindowScrolling
			? window.scrollY >= initialStickyTop.current
			: scrollTop > stickyTop;
		setIsSticky(isStickyNow);
	};

	useEffect(() => {
		const isWindowScrolling = scrollContainerRef?.current === undefined;
		const scrollContainer =  isWindowScrolling ? window : scrollContainerRef.current;
		scrollContainer.addEventListener('scroll', handleScroll);

		return () => {
			scrollContainer.removeEventListener('scroll', handleScroll);
		};
	}, [
		scrollContainerRef?.current,
		isDesktopResolution,
	]);

	if (isSticky) {
		cssClasses.push(styles.sticky__fixed);
	} else {
		cssClasses.filter(cssClass => cssClass !== styles.sticky__fixed);
	}

	return (
		<div
			className={cssClasses.join(' ')}
			{...otherProps}
		>
			{children}
		</div>
	);
};
